export default "__VITE_ASSET__gt08lsGl__"